export const baseUrl = process.env.NODE_ENV === 'production'
  ? 'https://task-ui-app.herokuapp.com/api'
  : 'http://localhost:8080/api';

export const sortByAlphapeticalOrder = (array: any[]) => array
  .sort((a: any, b: any) :number => {
    if (a.checklistTitle < b.checklistTitle) {
      return -1;
    }
    if (a.checklistTitle > b.checklistTitle) {
      return 1;
    }
    return 0;
  });
